import { StyledCustomButtons, StyledLoginForm } from './style';
import { Input } from '../../Input';
import { Button } from '../../Button';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useAuth } from '../../../hooks/useAuth';
import { Flex } from 'antd';
import { Divider } from '../../Divider';
import { Icon } from 'ui';
import PublicRoute from 'enums/publicRoutes';

export enum AuthType {
  Physical = 'PHYSICAL',
  Legal = 'LEGAL',
}

export const LoginForm = () => {
  const [forgottenEmail, setForgottenEmail] = useState(false);
  const [selectedAuthType, setSelectedAuthType] = useState(AuthType.Physical);

  const intl = useIntl();
  const APP_URL = window.runConfig.backendUrl;
  const navigate = useNavigate();

  const { login, isLoginLoading, isOpenModal, setIsOpenModal } = useAuth();

  useEffect(() => {
    if (isOpenModal) {
      setForgottenEmail(true);
    }
  }, [isOpenModal]);

  const handleSubmit = (values: any) => {
    if (login) {
      login(values);
    }
  };

  const handleGoogleAuth = () => {
    window.location.href = `${APP_URL}/api/v2/login/google`;
  };

  const [form] = StyledLoginForm.useForm();

  return (
    <StyledLoginForm form={form} onFinish={handleSubmit}>
      <div className={'inputs'}>
        <div className="login-title">
          {intl.formatMessage({ id: 'general.authorize' })}
        </div>
        <StyledCustomButtons>
          <div
            className={`custom-button ${selectedAuthType === AuthType.Physical ? 'active' : ''}`}
            onClick={() => setSelectedAuthType(AuthType.Physical)}
          >
            {intl.formatMessage({ id: 'login.private_person' })}
          </div>
          <div
            className={`custom-button ${selectedAuthType === AuthType.Legal ? 'active' : ''}`}
            onClick={() => setSelectedAuthType(AuthType.Legal)}
          >
            {intl.formatMessage({ id: 'login.legal_person' })}
          </div>
        </StyledCustomButtons>
        {selectedAuthType === AuthType.Physical ? (
          <>
            <div className={'registration-input-wrapper'}>
              <div className={'email'}>
                <span className="label">
                  {intl.formatMessage({ id: 'login.e_mail' })}
                </span>
                <Input
                  size={'large'}
                  name={'email'}
                  validations={['email', 'required']}
                />
              </div>
              <div className={'pw'}>
                <span className="label">
                  {intl.formatMessage({ id: 'login.password' })}
                </span>
                <Input
                  password
                  size={'large'}
                  name={'password'}
                  validations={'required'}
                />
              </div>
            </div>
            <div className={'reset-password'}>
              <div
                onClick={() => navigate(PublicRoute.RESET_PASSWORD)}
                className={'text'}
              >
                {intl.formatMessage({ id: 'login.forgot_password' })}
              </div>
              {forgottenEmail && (
                <div className={'text'} onClick={() => setIsOpenModal(true)}>
                  {intl.formatMessage({ id: 'login.resend_email' })}
                </div>
              )}
            </div>
            <div className={'registration-button-wrapper'}>
              <div className={'registration-buttons'}>
                <Button
                  className={'cstm-btn submit'}
                  label={intl.formatMessage({ id: 'login.title' })}
                  size={'large'}
                  htmlType={'submit'}
                  loading={isLoginLoading}
                  disabled={isLoginLoading}
                />
                <Divider />
                <Flex gap={10}>
                  <Button
                    label={intl.formatMessage({ id: 'login.use_google' })}
                    className={'cstm-btn google'}
                    icon={<img src={'/google.png'} alt="Google" />}
                    onClick={handleGoogleAuth}
                  />
                  {/* <Button
                    label={intl.formatMessage({ id: 'login.use_facebook' })}
                    className={'cstm-btn google'}
                    icon={<img src={'/facebook.png'} alt="Facebook" />}
                    onClick={() =>
                      (window.location.href = `${APP_URL}/api/v2/login/facebook`)
                    }
                  /> */}
                </Flex>
              </div>
            </div>
            <div className={'no-acc-reg'}>
              {intl.formatMessage({ id: 'login.need_acc' })}
              <a href={PublicRoute.REGISTER} className="login_link">
                {intl.formatMessage({ id: 'login.register' })}
              </a>
            </div>
          </>
        ) : (
          <div className={'registration-button-wrapper'}>
            <div className={'registration-buttons'}>
              <Button
                label={' '}
                className={'cstm-btn google'}
                icon={<img src={'/latvijalv.svg'} alt="Latvija.lv" />}
                onClick={() => window.location.replace(APP_URL + '/vpm/login')}
              />
            </div>
          </div>
        )}
        <div className={'home-button-wrapper'}>
          <Button
            label={intl.formatMessage({ id: 'navigation.to_start' })}
            className={'cstm-btn home'}
            onClick={() => navigate(PublicRoute.HOME)}
            icon={<Icon name={'got-to-home-page-auth-arrow'} />}
            type={'link'}
          />
        </div>
      </div>
    </StyledLoginForm>
  );
};
